import { useState, useEffect } from 'react'
import { FolderOpen, Users } from 'lucide-react'

const API_URL = import.meta.env.VITE_API_URL || ''

/**
 * ChatFooterStats - Shows total projects created + active users at the bottom of chat.
 * Visible to everyone. Polls every 60 seconds.
 * 
 * Usage: <ChatFooterStats />
 */
export default function ChatFooterStats() {
  const [stats, setStats] = useState({ total_projects: 0, active_users: 0 })

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_URL}/activity/public-stats`)
        const data = await res.json()
        setStats(data)
      } catch (err) {
        // Silent fail
      }
    }

    fetchStats()
    const interval = setInterval(fetchStats, 60000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center gap-4 py-2 px-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50">
      <div className="flex items-center gap-1.5 text-xs text-slate-400">
        <FolderOpen className="w-3 h-3" />
        <span><strong className="text-slate-500 dark:text-slate-300">{stats.total_projects.toLocaleString()}</strong> projects created</span>
      </div>
      <span className="text-slate-300 dark:text-slate-600">•</span>
      <div className="flex items-center gap-1.5 text-xs text-slate-400">
        <Users className="w-3 h-3" />
        <span><strong className="text-emerald-500">{stats.active_users}</strong> crafters online</span>
      </div>
    </div>
  )
}